import { IWidgetSettingsFormData } from '@/models/Widget/settings';
import { EWidgetThemes } from '@/models/Widget/themes';

export function configWidgetFormDataFactory(): IWidgetSettingsFormData {
  return {
    enabled: true,
    widgetStyle: {
      icon: 'coin',
      color: EWidgetThemes.BLUE,
      launcher: 'only',
      text: ''
    },
    placement: {
      positioning: 'bottomLeft',
      mobile: {
        horizontally: 30,
        vertically: 30
      },
      desktop: {
        horizontally: 30,
        vertically: 30
      }
    },
    welcome: {
      desktopEnable: true,
      mobileEnable: true,
      enable: true,
      title: 'Hey there 👋',
      description: "You'll be rewarded with your loyalty Coins after checkout!",
      visibility: 'both'
    },
    previewState: 'popover',
    device: 'desktop'
  };
}
